export const existedCompanyname = 'tomcompany';
export const existedEmail = 'tom@mail.com';
export const existedHostname = 'tomfree';
export const testRegion = 'NA';
export const exceptionCausingName = 'mock_triggering_exception_error_only';
export const invalidPassword = ' mock_triggering_invalid_password  ';
export const testInstanceUrl = 'https://coolcompany.dev.xmatters.com';
export const timeoutCausingName = 'mock-triggering-api-timeout-error';
export const triggerCompleteSignup409 = 'hostname-to-trigger-409';

export const pollingTimeoutCausingName = 'mock_triggering_polling_timeout_only';
export const registrationIdForHappyPath = 'e85e472d-dfb2-47ec-9fcd-happy-path';
export const registrationIdForPollingTimeout = 'f16y4a-m91-jm1-polling-timeout';
